var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.668,
    height: 100.849,
    viewBox: "0 0 138.668 100.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck",
    d: "M108.652,97.395a9.455,9.455,0,1,1,9.455-9.455,9.455,9.455,0,0,1-9.455,9.455m9.455-56.728,12.354,15.758H102.349V40.667M33.015,97.395A9.455,9.455,0,1,1,42.47,87.94a9.455,9.455,0,0,1-9.455,9.455m88.243-66.182H102.349V6H14.106A12.563,12.563,0,0,0,1.5,18.606V87.94H14.106a18.909,18.909,0,1,0,37.818,0H89.743a18.909,18.909,0,1,0,37.818,0h12.606V56.425Z",
    transform: "translate(-1.5 -6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.9b4c1a6335c5cb18331f19d3e7023f01.svg";
export { ForwardRef as ReactComponent };